export const parseBlogContent = (htmlContent: string): [string, string[]][] => {
    const blocks = htmlContent.split('<h2>');

    blocks.shift();

    return blocks.map((block) => {
        const [title, data] = block.split('</h2>');
        const pureTitle = title
            .replace(/<strong>/g, '')
            .replace(/<\/strong>/g, '')
            .replace(/^\d{1,2}\. /, '');

        const items: string[] = data
            ?.split('<h3>')
            ?.map((part, idx) => {
                if (idx === 0) {
                    return '';
                } else {
                    return part.split('</h3>')[0];
                }
            })
            ?.filter((content) => !!content);

        return [pureTitle, items];
    });
};
